import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TextField } from "@material-ui/core";
import withLoader from "../../components/layouts/WithLoader";
import JournalCaisseService from "../../services/PosService/JournalCaisseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@mui/material";
import DataTableJournauxCashRegister from "../../ui/DataTableJournauxCashRegister";
import CardPayementTickets from "../../components/cardBox/CardPayementTickets";
import { Modal, Button, Form } from "react-bootstrap";
import toastr from "toastr";
import CashRegisterService from "../../services/PosService/CashRegisterService";

const JournalCaisse = ({ startLoading, stopLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [creationDate, setCreationDate] = useState(null);

  const [availableJournaux, setAvailableJournaux] = useState([]);
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [showTable, setShowTable] = useState(false);
  const [btnClear, setBtnClear] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [type, setType] = useState(null);
  //payement total card
  const [espece, setEspece] = useState(0);
  const [cheque, setCheque] = useState(0);
  const [card, setcard] = useState(0);
  const [virement, setvirement] = useState(0);
  const [carteCadeau, setCarteCadeau] = useState(0);

  const [totalCard, setTotalCard] = useState(null);
  const [totalCarteCadeau, setTotalCarteCadeau] = useState(null);
  const [totalCash, setTotalCash] = useState(null);
  const [totalCheck, setTotalCheck] = useState(null);
  const [totalVirement, setTotalVirement] = useState(null);
  const [totalPass, setTotalPass] = useState(null);
  const [totalRSS, setTotalRSS] = useState(null);
  const [totalTPEPASS, setTotalTPEPASS] = useState(null);
  // saisie 
  const [incomeCard, setIncomeCard] = useState(null);
  const [incomeCarteCadeau, setIncomeCarteCadeau] = useState(null);
  const [incomeCash, setIncomeCash] = useState(null);
  const [incomeCheck, setIncomeCheck] = useState(null);
  const [incomeVirement, setIncomeVirement] = useState(null);
  const [incomePass, setIncomePass] = useState(null);
  const [incomeRSS, setIncomeRSS] = useState(null);
  const [incomeTPEPASS, setIncomeTPEPASS] = useState(null);
  const handleModalClose = () => {
    setModalVisible(false);
  };

  const handleModalOpen = () => {
    setModalVisible(true);
  };
  //alert
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  useEffect(() => {
    const status = localStorage.getItem("status");
    if (status === null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(status));
    }
    const typeGetJournaux = localStorage.getItem("typeGetJournaux");
    setType(typeGetJournaux);
  }, []);

  useEffect(() => {
    if (userRole.includes("ADMIN")) {
      if (type == "caisse") {
        onGetAllJournauxCaisse();
        getAllPayementJournaleCaisse();
      } else if (type == "shop") {
        onGetJournauxByShop();
        getAllPayementJournaleShop();
      }
    } else if (userRole.includes("DIRECTEUR_MAGASIN")) {
      if (type == "caisse") {
        onGetJournauxCaisseByUser();
        getAllPayementJournaleCaisse();
      } else if (type == "shop") {
        onGetJournauxByShop();
        getAllPayementJournaleShop();
      }
    }
  }, [userRole]);

  const onGetJournauxByShop = () => {
    startLoading();
    JournalCaisseService.getAllJournauxByShop(
      localStorage.getItem("idShopJournaux"),
      dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableJournaux(response?.data?.success);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onGetJournauxByShopByFilter = (dateBegin, dateEnd) => {
    startLoading();
    JournalCaisseService.getAllJournauxByShop(
      localStorage.getItem("idShopJournaux"),
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableJournaux(response?.data?.success);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onGetJournauxCaisseByUser = () => {
    startLoading();
    JournalCaisseService.getAllJournauxByCaisseAndUser(
      localStorage.getItem("idCaisse"),
      getCurrentUserId(),
      dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableJournaux(response?.data?.success);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

   const handleSaveEnregistrer = () => {
      const data = {
        creationDate: creationDate + ":00",
        idCashRegister:localStorage.getItem("idCaisse"),
       
        totalCard: totalCard,
        totalCarteCadeau: totalCarteCadeau,
        totalCash: totalCash,
        totalCheck: totalCheck,
        totalVirement: totalVirement,
        totalRSS: totalRSS,
        incomeCard: incomeCard,
        incomeCarteCadeau: incomeCarteCadeau,
        incomeCash: incomeCash,
        incomeCheck: incomeCheck,
        incomeVirement: incomeVirement,
        incomeRSS: incomeRSS,
      };
      CashRegisterService.addNewJournalCaisse(getCurrentUserId(), data)
        .then(() => {
          onGetJournauxByFiltersHandler();
          toastr.success("Le journal de caisse a été créé avec succès.");
          setModalVisible(false);
        })
        .catch((error) => {
          toastr.error("Une erreur est survenue lors de la creation du journal de caisse.");
          console.error("Error updating journal de caisse:", error);
        });
    };
  const onGetJournauxCaisseByUserByFilter = (dateBegin, dateEnd) => {
    startLoading();
    JournalCaisseService.getAllJournauxByCaisseAndUser(
      localStorage.getItem("idCaisse"),
      getCurrentUserId(),
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableJournaux(response?.data?.success);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onGetAllJournauxCaisse = () => {
    startLoading();
    JournalCaisseService.getAllJournauxByCaisse(
      localStorage.getItem("idCaisse"),
      dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableJournaux(response?.data?.success);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onGetAllJournauxCaisseByFilter = (dateBegin, dateEnd) => {
    startLoading();
    JournalCaisseService.getAllJournauxByCaisse(
      localStorage.getItem("idCaisse"),
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableJournaux(response?.data?.success);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const onGetJournauxByFiltersHandler = () => {
    // setShowTable(false);
    setBtnClear(true);
    if (userRole.includes("ADMIN")) {
      if (type == "caisse") {
        onGetAllJournauxCaisse();
        getAllPayementJournaleCaisse();
      } else if (type == "shop") {
        onGetJournauxByShop();
        getAllPayementJournaleShop();
      }
    } else if (userRole.includes("DIRECTEUR_MAGASIN")) {
      if (type == "caisse") {
        onGetJournauxCaisseByUser();
        getAllPayementJournaleCaisse();
      } else if (type == "shop") {
        onGetJournauxByShop();
        getAllPayementJournaleShop();
      }
    }
  };
  const onClearGetJournauxByFiltersHandler = () => {
    setDateBegin("any");
    setDateEnd("any");
    setShowTable(false);
    setBtnClear(false);
    if (userRole.includes("ADMIN")) {
      if (type == "caisse") {
        onGetAllJournauxCaisseByFilter("any", "any");
        getAllPayementJournaleCaisseByFilter("any", "any");
      } else if (type == "shop") {
        onGetJournauxByShopByFilter("any", "any");
        getAllPayementJournaleShopByFilter("any", "any");
      }
    } else if (userRole.includes("DIRECTEUR_MAGASIN")) {
      if (type == "caisse") {
        onGetJournauxCaisseByUserByFilter("any", "any");
        getAllPayementJournaleCaisseByFilter("any", "any");
      } else if (type == "shop") {
        onGetJournauxByShopByFilter("any", "any");
        getAllPayementJournaleShopByFilter("any", "any");
      }
    }
  };

  // useEffect(() => {
  //   if (dateBegin === ":59") {
  //     setDateBegin("any");
  //   }
  //   if (dateEnd === ":59") {
  //     setDateEnd("any");
  //   }
  // }, [dateBegin, dateEnd]);

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value);
    // 2024-11-13T11:51:59
    // 2024-11-22
    // console.log(event.target.value.concat("T00:00:00"))
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value);
  };

  const filterTableJournaux = () => {
    if (availableJournaux && availableJournaux?.length > 0) {
      return (
        <DataTableJournauxCashRegister
          journauxCaisse={availableJournaux}
          userRole={userRole}
          onGetJournauxByFiltersHandler={onGetJournauxByFiltersHandler}
        />
      );
    }
  };
  const getAllPayementJournaleShop = () => {
    startLoading();
    JournalCaisseService.getAllPayementJournaleShop(
      localStorage.getItem("idShopJournaux"),
      dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
      .then((response) => {
        if (response?.data?.success) {
          //totalPayement
          setEspece(response?.data?.success?.espece);
          setcard(response?.data?.success?.card);
          setvirement(response?.data?.success?.virement);
          setCarteCadeau(response?.data?.success?.carteCadeau);
          setCheque(response?.data?.success?.cheque);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const getAllPayementJournaleCaisse = () => {
    startLoading();
    JournalCaisseService.getAllPayementJournaleCaisse(
      localStorage.getItem("idCaisse"),
      dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
      .then((response) => {
        if (response?.data?.success) {
          //totalPayement
          setEspece(response?.data?.success?.espece);
          setcard(response?.data?.success?.card);
          setvirement(response?.data?.success?.virement);
          setCarteCadeau(response?.data?.success?.carteCadeau);
          setCheque(response?.data?.success?.cheque);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  //by filter
  const getAllPayementJournaleShopByFilter = (dateBegin, dateEnd) => {
    startLoading();
    JournalCaisseService.getAllPayementJournaleShop(
      localStorage.getItem("idShopJournaux"),
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (response?.data?.success) {
          //totalPayement
          setEspece(response?.data?.success?.espece);
          setcard(response?.data?.success?.card);
          setvirement(response?.data?.success?.virement);
          setCarteCadeau(response?.data?.success?.carteCadeau);
          setCheque(response?.data?.success?.cheque);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const getAllPayementJournaleCaisseByFilter = (dateBegin, dateEnd) => {
    startLoading();
    JournalCaisseService.getAllPayementJournaleCaisse(
      localStorage.getItem("idCaisse"),
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (response?.data?.success) {
          //totalPayement
          setEspece(response?.data?.success?.espece);
          setcard(response?.data?.success?.card);
          setvirement(response?.data?.success?.virement);
          setCarteCadeau(response?.data?.success?.carteCadeau);
          setCheque(response?.data?.success?.cheque);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">Les journaux de caisse</h5>
              {(type === "caisse") && (
                <button className="btn btn-dark float-right" onClick={() => {
                  handleModalOpen();
                  setCreationDate(new Date().toISOString().slice(0, 16))
                  setTotalCard(0)
                  setTotalCarteCadeau(0)
                  setTotalCash(0)
                  setTotalCheck(0)
                  setTotalVirement(0)
                  setTotalRSS(0)
                  setIncomeCard(0)
                  setIncomeCarteCadeau(0)
                  setIncomeCash(0)
                  setIncomeCheck(0)
                  setIncomeVirement(0)
                  setIncomeRSS(0)
                }}>Créer un nouveau journal de caisse</button>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="date"
                          // label="Date Début"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="date"
                          // label="Date fin"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="row">
                    {btnClear && (
                      <div className="col-sm-6 text-center">
                        <button
                          className="btn btn-dark"
                          onClick={onClearGetJournauxByFiltersHandler}
                        >
                          Annuler Filter
                        </button>
                      </div>
                    )}
                    <div
                      className={
                        !btnClear
                          ? "col-sm-12 text-center"
                          : "col-sm-6 text-center"
                      }
                    >
                      <button
                        className="btn btn-dark"
                        onClick={onGetJournauxByFiltersHandler}
                      >
                        Valider le choix
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CardPayementTickets
        espece={espece}
        virement={virement}
        carteCadeau={carteCadeau}
        card={card}
        cheque={cheque}
      />

      <section class="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">{filterTableJournaux()}</div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>


        <Modal show={modalVisible} onHide={handleModalClose} centered>
              <Modal.Header>
                <Modal.Title>Ajouter un nouveau Journal de Caisse</Modal.Title>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleModalClose}
                  style={{ fontSize: "1.5rem", background: "none", border: "none" }}
                >
                  ×
                </button>
              </Modal.Header>
              <Modal.Body>
                {/* Display reference */}
      
                {/* Date Input */}
                <Form.Group>
                  <Form.Label>Modifier la Date de Création</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={creationDate}
                    onChange={(e) => setCreationDate(e.target.value)}
                  />
                </Form.Group>
       {/* Total Cash */}
                <div className="row">
                  <div className="col-sm-6">
                    <Form.Group>
                      <Form.Label>Système Espèce</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={totalCash}
                        onChange={(e) => setTotalCash(Number(e.target.value))}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm-6">
                    <Form.Group>
                      <Form.Label>Saisie Espèce</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={incomeCash}
                        onChange={(e) => setIncomeCash(Number(e.target.value))}
                      />
                    </Form.Group>
                  </div>
                </div>
              
       {/* Total Check */}
      
                <div className="row">
                  <div className="col-sm-6">
                    <Form.Group>
                      <Form.Label>Système Chèque</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={totalCheck}
                        onChange={(e) => setTotalCheck(Number(e.target.value))}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm-6">
                    <Form.Group>
                      <Form.Label>Saisie Chèque</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={incomeCheck}
                        onChange={(e) => setIncomeCheck(Number(e.target.value))}
                      />
                    </Form.Group>
                  </div>
                </div>
      
                
        {/* Total Card */}
                <div className="row">
                  <div className="col-sm-6">
                    <Form.Group>
                      <Form.Label>Système TPE</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={totalCard}
                        onChange={(e) => setTotalCard(Number(e.target.value))}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm-6">
                    <Form.Group>
                      <Form.Label>Saisie TPE</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={incomeCard}
                        onChange={(e) => setIncomeCard(Number(e.target.value))}
                      />
                    </Form.Group>
                  </div>
                </div>
      
               
      
               {/* Total Carte Cadeau */}
                <div className="row">
                  <div className="col-sm-6">
                    <Form.Group>
                      <Form.Label>Système Carte Cadeau</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={totalCarteCadeau}
                        onChange={(e) => setTotalCarteCadeau(Number(e.target.value))}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm-6">
                    <Form.Group>
                      <Form.Label>Saisie Carte Cadeau</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={incomeCarteCadeau}
                        onChange={(e) => setIncomeCarteCadeau(Number(e.target.value))}
                      />
                    </Form.Group>
                  </div>
                </div>
      
      
      
                {/* Total Virement */}
      
                <div className="row">
                  <div className="col-sm-6">
                       <Form.Group>
                  <Form.Label>Système Virement</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={totalVirement}
                    onChange={(e) => setTotalVirement(Number(e.target.value))}
                  />
                </Form.Group>
                  </div>
                  <div className="col-sm-6">
                       <Form.Group>
                  <Form.Label>Saisie Virement</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={incomeVirement}
                    onChange={(e) => setIncomeVirement(Number(e.target.value))}
                  />
                </Form.Group>
                  </div>
                </div>
            
      
               
                 <div className="row">
                  <div className="col-sm-6">
             <Form.Group>
                  <Form.Label>Système Ristourne </Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={totalRSS}
                    onChange={(e) => setTotalRSS(Number(e.target.value))}
                  />
                </Form.Group>
                  </div>
                  <div className="col-sm-6">
                   <Form.Group>
                  <Form.Label>Saisie Ristourne </Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={incomeRSS}
                    onChange={(e) => setIncomeRSS(Number(e.target.value))}
                  />
                </Form.Group>
                  </div>
                </div>
               
               
              
              </Modal.Body>
      
              <Modal.Footer>
                <Button variant="primary" onClick={handleSaveEnregistrer}>
                  Enregistrer
                </Button>
              </Modal.Footer>
            </Modal>
    </div>
  );
};
export default withLoader(JournalCaisse);
